import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiForgotValidatecodeMutationRequest,
  PostApiForgotValidatecodeMutationResponse,
  PostApiForgotValidatecode401,
  PostApiForgotValidatecode403,
} from "../../../types/PostApiForgotValidatecode";

export function getPostApiForgotValidatecodeUrl() {
  return `/api/Forgot/ValidateCode` as const;
}

/**
 * {@link /api/Forgot/ValidateCode}
 */
export async function postApiForgotValidatecode(
  data?: PostApiForgotValidatecodeMutationRequest,
  config: Partial<RequestConfig<PostApiForgotValidatecodeMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiForgotValidatecodeMutationResponse,
    ResponseErrorConfig<
      PostApiForgotValidatecode401 | PostApiForgotValidatecode403
    >,
    PostApiForgotValidatecodeMutationRequest
  >({
    method: "POST",
    url: getPostApiForgotValidatecodeUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
